import ListIcon from "./ListIcon.mjs";

export default class MyControlIcon extends ListIcon {}
